<template>
  <span v-if="isLoading || hasAlert">
    <template v-if="hasAlert">
      <i
        :id="'alert' + orcamentoId"
        class="fa fa-exclamation-triangle text-danger d-inline"
      ></i>
      <b-popover
        :target="'alert' + orcamentoId"
        triggers="hover"
        placement="auto"
      >
        <template v-slot:title>Atenção</template>
        <p v-if="data == null">
          Não foi possível fazer a consulta de mudanças de produtos, tente
          novamente mais tarde.
        </p>
        <p>
          Abra o orçamento para edição e clique em Atualizar Produtos para
          resolver os problemas.
        </p>
      </b-popover>
    </template>
  </span>
</template>

<style scoped>
.table-container {
  height: 15rem;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>

<script>
import Orcamento from "../../../services/orcamento";

export default {
  name: "OrcamentoAlerta",
  props: {
    id: {
      type: String,
      default: "OrcamentoAlerta"
    },
    name: {
      type: String,
      default: "OrcamentoAlerta"
    },
    orcamentoId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasAlert() {
      if (this.data == null) return false;
      if (this.data.length <= 0) return false;
      return Object.keys(this.data).length > 0;
    }
  },
  data: () => ({
    isLoading: false,
    data: null
  }),
  mounted() {
    this.getProductChangeAlerts(this.orcamentoId);
  },
  methods: {
    getProductChangeAlerts(orcamento_id) {
      this.isLoading = true;
      this.data = null;
      Orcamento.getProductChangeAlerts(orcamento_id)
        .then(response => {
          this.data = response.data.data;
        })
        .catch(e => {
          if (
            !(
              e.response &&
              e.response.status &&
              e.response.status === 404 &&
              e.response.data
            )
          ) {
            this.$helper.showErrorResponse(e);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
